import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';

import { ButtonArrowBackIcon, ButtonArrowForwardIcon } from 'assets/icons';

const styles = {
  button: ({ palette }, disabled) => ({
    padding: 2,
    position: 'absolute',
    top: '43%',
    color: palette.text.primary,
    ...(disabled && { display: 'none' }),

    '&:first-of-type': {
      left: 0,
    },

    '&:last-of-type': {
      right: 0,
    },

    '.MuiSvgIcon-root': {
      width: 40,
      height: 40,
    },
  }),
};

const SwiperButton = ({ disabled = false, onClick, isBack = false }) => (
  <IconButton onClick={onClick} sx={(theme) => styles.button(theme, disabled)}>
    {isBack ? <ButtonArrowBackIcon /> : <ButtonArrowForwardIcon />}
  </IconButton>
);

SwiperButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isBack: PropTypes.bool,
};
export default SwiperButton;
